import { C1DisplayNameSkeleton } from 'components/core/display-name-details'
import { MinimalAPIError } from 'components/core/errors/api'
import {
    C1PolicyDisplayName,
    C1PolicyDisplayNameProps,
} from 'components/pages/policy/display-name/C1PolicyDisplayName'
import { GetPolicyRequest } from 'pbts/c1/api/policy/v1/policy'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { getPolicyApi } from 'redux_toolkit/policies'

export type C1PolicyDisplayNameWithFetchProps = {
    policyId: string
} & Omit<C1PolicyDisplayNameProps, 'policy'>

export const C1PolicyDisplayNameWithFetch: FC<C1PolicyDisplayNameWithFetchProps> = ({
    policyId,
    ...rest
}) => {
    const { data, error, isLoading, isError } = getPolicyApi.useGet(
        GetPolicyRequest.create({ id: policyId }),
        { actionable: !!policyId },
    )

    if (isLoading) {
        return <C1DisplayNameSkeleton />
    }

    if ((isError && error) || !data) {
        return <MinimalAPIError
            err={<FormattedMessage id="component_api_error_policy" defaultMessage="Error fetching policy" />}
        />
    }

    return <C1PolicyDisplayName
        {...rest}
        policy={data}
    />
}
